import { render, staticRenderFns } from "./bjQuestion.vue?vue&type=template&id=f0052ce8&scoped=true&"
import script from "./bjQuestion.vue?vue&type=script&lang=js&"
export * from "./bjQuestion.vue?vue&type=script&lang=js&"
import style0 from "./bjQuestion.vue?vue&type=style&index=0&id=f0052ce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0052ce8",
  null
  
)

export default component.exports